module.exports = __webpack_public_path__ + "img/f428ede00da52c3d066a2cfc7ece4774.png";